import { render, staticRenderFns } from "./DetailPrealert.vue?vue&type=template&id=a68a0f2c"
import script from "./DetailPrealert.vue?vue&type=script&lang=js"
export * from "./DetailPrealert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports